<div class="flex flex-col items-center">
  <div
    #canvas
    (click)="downloadQrCode()"
    [class.cursor-pointer]="canDownload"
  ></div>
</div>
